import React from 'react';

const RequestError = () => {
  return (
    <div>
      <p className="text-4xl mb-36 px-36 text-white tracking-widest text-center">
        Oops! Looks like the service encountered an error while processing that
        request. Please try again later. We apologise for any inconvenience
        caused.
      </p>
    </div>
  );
};

export default RequestError;
